export default __webpack_public_path__ + "public/icons/file-upload-icon.svg?e10c679de916c1630434be814c4eb3a9";